import reducer from './reducers';
import * as thirdAnalysesActions from './actions';
import * as thirdAnalysesSelectors from './selectors';

export { thirdAnalysesActions, thirdAnalysesSelectors };
export default reducer;